import React, { useId } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

/** "Open buildings →" style link used in section headings and list rows. */
export const TextLink = ({ to, children }) => (
  <Link
    to={to}
    className="inline-flex items-center gap-1 text-[13px] font-medium text-lb-green-primary no-underline hover:underline focus-ring rounded"
  >
    {children}
    <ArrowRight size={13} aria-hidden="true" />
  </Link>
);

/** A titled block of the home page, with an optional count and action link. */
export const HomeSection = ({ title, count, action, children }) => {
  const headingId = useId();
  return (
    <section aria-labelledby={headingId}>
      <div className="flex items-baseline justify-between gap-3 mb-3">
        <h2 id={headingId} className="m-0 text-[16px] font-semibold text-lb-ink-strong">
          {title}
          {count > 0 && <span className="ml-2 text-[13px] font-medium text-lb-muted tabular-nums">{count}</span>}
        </h2>
        {action}
      </div>
      {children}
    </section>
  );
};
